import { ArtistChip } from './ArtistChip';
import { TopBottomLayout } from './TopBottomLayout';

const CustomCardComponents = {
  TopBottomLayout,
  ArtistInfoChip: ArtistChip,
};

export default CustomCardComponents;
